import React from "react";
import "./Register.css";
import Login from "../Login/Login";
const Register = () => {
  return (
    <div className="register-container">
      <div className="register-inner-card">
        <div className="register-inner-first-card">
          <img src="" alt="" />
        </div>
        <div className="register-inner-second-card">
          <Login />
        </div>
      </div>
    </div>
  );
};

export default Register;
